<template>
<div class="inner_right">
  <!-- 普通用户评论 -->
  <div v-if="!isRoomTeacher && !isRoomGuest">
    <div class="user-title clearfix">
      <span @click="tab = 'chat'" :class="{titlecolor: tab === 'chat'}">评论</span>
      <span @click="tab = 'paper'" :class="{titlecolor: tab === 'paper'}">问答</span>
      <span><nuxt-link to="/pay" target="_blank" rel="noopener">充值</nuxt-link></span>
    </div>
    <div class="wrap">
      <review v-show="tab === 'chat'"></review>
      <div v-show="tab === 'paper' && !(paperFreeNum == 0 && paperPrice == 0)" class="wrap_scrip">
      	<!--新的-->
      	<textarea name="" rows="" v-model="paperContent"  cols="" placeholder="请输入提问问题"></textarea>
      	<p class="action_wrap">
      		<span class="left">老师当前设置的问答价格为<i>{{paperPrice}}</i>G币/次</span> <button type="button" @click="handlePaper" class="right">提交</button>
      	</p>
      </div>
      <div class="end_free_num" v-show="tab === 'paper' && paperFreeNum ==  0 && paperPrice == 0">
      	<div class="icon_wrap left">
      		<img src="~assets/jz.png" alt="禁止图片" />
      	</div>
      	<div class="warning_wrap left">
      		<p>您今日的免费提问次数已用完</p>
      		<p>您可以在评论区跟老师互动</p>
      	</div>
      </div>
    </div>
  </div>
  <!-- 老师评论 -->
  <div v-else>
    <div class="teacher-title clearfix">
     	<div @click="tab = 'chat'" class="hudong left" :class="{activecolor: tab === 'chat'}">
        <span>右侧互动</span>
      </div>
      <div @click="tab = 'paper'"  class="wenda left" :class="{activecolor: tab === 'paper' }">
        <span>问答设置</span>
      </div>
    </div>
    <div class="wrap">
      <review v-if="tab === 'chat'"></review>
      <div class="wenda_set">
      	<p class="num_wrap">当前的价格为<span>{{paperPrice}}</span>G币/次</p>
      	<p class="btn_wrap"><input type="text" v-model="price" placeholder="请输入要设置的新价格" /><button @click="handleSetPrice" type="button">提交</button></p>
      </div>
    </div>
    <div class="teacher_all_use">
      <teacher-order></teacher-order>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Dialog from '@/utils/Dialog'
import Review from '@/components/room/Review'
import TeacherOrder from '@/components/room/TeacherOrder'

export default {
  data() {
    return {
      tab: 'chat',
      // 纸条
      paperContent: '',
      price: ''
    }
  },
  methods: {
    // 发送纸条
    handlePaper () {
      if (!this.$isLogin()) {
        Dialog.login()
        return false
      }
      // 提问内容不为空
      if (!this.paperContent) {
        this.$notify.error({
          title: '错误',
          message: '内容不能为空！'
        })
        return
      }

      // G币检测
      if (this.paperPrice > 0 && this.authUser.gcoins < this.paperPrice) {
        this.$notify.error({
          title: '错误',
          message: '您的G币不足'
        })
        return
      }

      const msg = this.paperPrice > 0 ? `该纸条共计消费${this.paperPrice}个G币，请确认支付` : `您将使用一次免费问机会，请确认`
      // 发纸条确认
      Dialog.confirm(msg).then(_ => {
        // 发纸条请求
        this.$axios._post('/Ask/Add', {
          teacher: this.roomData.teacherId,
          content: this.paperContent,
          gcoins: this.paperPrice
        }).then(resp => {
          this.paperContent = ''
					this.paperFreeNum -= 1
          this.$store.commit('user/setGcoins', this.authUser.gcoins - this.paperPrice)
          this.$notify.success({
            title: '成功',
            message: '提问成功'
          })
        })
      })
    },
    handleSetPrice () {
      this.price = parseInt(this.price) > 0 ? parseInt(this.price) : 0

      Dialog.confirm(`您确定要把问答价格设置为${this.price > 0 ? this.price + 'G币' : '免费'}吗？`).then(_ => {
        this.$axios._post('/Teacher/QuestionPrice', { price: this.price }).then(resp => {
          this.$store.commit('teacher/setAskPrice', this.price)
          this.price = ''
    			this.$notify.success({
            title: '成功',
            message: '成功设置问答价格'
          })
        })
      })
		}
  },
  computed: {
    ...mapState({
      roomData: state => state.room.data,
      //免费问答的剩余次数
      paperFreeNum: state => state.user.ask.free,
      // 问答价格
      paperPrice: state => state.teacher.data.questionPrice,
      // 用户
      authUser: state => state.user.data
    }),
    ...mapGetters({
      isRoomTeacher: 'room/isTeacher',
      isRoomGuest: 'room/isGuest'
    })
  },
  components: {
    Review,
    TeacherOrder
  }
}
</script>

<style lang="less" scoped>
.inner_right { width: 414px; background: #f7f7f7;
  .user-title { border-top: 1px solid #e2e2e2;
    span { float: left; width: 33.333333%; text-align: center; line-height: 39px; height: 39px; border-right: 1px solid #E2E2E2; border-bottom: 2px solid #e3e3e3; cursor: pointer;
      &:hover,a:hover { color: #e43a3a; }
    }
    .titlecolor { border-bottom: 2px solid #e43a3a; color: #e43a3a;}
  }
  .teacher-title { border-top:1px solid #dadada; font-size: 14px; background: #f7f7f7;
    div { width: 50%; text-align: center; border-bottom:3px solid #F7F7F7; cursor: pointer;
      span { border-right: 1px solid #e7e7e7; display: inline-block; width: 100%; line-height: 20px; margin: 11px 0; }
    }
  	.activecolor { border-color: #e43a3d; }
  }
  .wrap { height: 120px; position: relative;
    .wrap_scrip { width: 414px; height: 100%; position: absolute; top: 0; background: #fff; padding: 5px;
  		textarea { width: 400px; height: 80px; resize: none; border: none; outline: none; }
  		.action_wrap { height: 30px;
  			span { font-size: 14px; padding-top: 5px; color: #676767;
          i { color: #e33a3d; font-size: 14px; }
        }
  			button { background: #e43a3d; color: #fff; width: 78px; height: 30px; border: none; border-radius: 5px; font-size: 14px;}
  		}
    }
    .end_free_num {  width: 414px; height: 100%; background: #fff; padding-top: 38px; padding-left: 86px;
    	.icon_wrap { width:40px ; height: 40px; margin-right: 9px;
    		img { width: 40px; height: 40px;}
    	}
    	.warning_wrap { width: 190px; height: 40px;
    		p { line-height: 18px; font-size: 14px; color: #999;  }
    	}
    }
   .wenda_set { background: #fff; width: 100%; height: 100%; padding-left: 14px;
   		.num_wrap { padding-top: 26px; padding-bottom: 21px; font-size: 14px; color: #666; span { font-size: 14px; color: #e43941;}}
   		.btn_wrap { height: 30px;
   			input { width: 288px; height: 30px; border: 1px solid #ddd; outline: none;  padding-left: 10px;}
   			button { width: 78px; height: 30px;  border: none; border-radius: 5px; background: #e43a3d; font-size: 14px; color: #fff; margin-left: 11px; outline: none; cursor: pointer;}
   		}
   }
  }
}
</style>
